// Button types
const ActionType = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
  DELETE: 'delete',
  APPROVE: 'approve',
  REJECT: 'reject',
  SUBMIT: 'submit',
  CANCEL: 'cancel',
  RESET: 'reset',
  SUBMIT_APPROVAL: 'submitApproval',
  SUBMIT_APPROVAL_DIALOG: 'submitApprovalDialog',
  SUBMIT_APPROVAL_TEMPLATE: 'submitApprovalTemplate',
  SUBMIT_APPROVAL_TEMPLATE_DIALOG: 'submitApprovalTemplateDialog',
  SUBMIT_APPROVAL_INSTANCE: 'submitApprovalInstance',
};


export default ActionType;